import React  from 'react';
import { HeadLine } from '../../../components/common/Headline';
import {JsonNumComdinations, JsonNumWictory} from "../../../DataJsons/TwoSections"

export const TwoSections = (props) => {

    let RenderCards = (props) => {
        return(
            <div className="block_card">
                <div className="head">
                    <div className="head_content">
                        <h3>Лотерея #137</h3>
                        <svg width="21" height="2" viewBox="0 0 21 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line x1="0.681946" y1="0.818115" x2="20.6819" y2="0.818115" stroke="#212129"/>
                        </svg>
                    </div>
                    <div className="data_ends">
                        <h3>14.11.2020</h3>
                        <p>Дата завершения</p>
                    </div>
                </div>
                <div className="wictory_combinations">
                    <h1>Выигравшая комбинация:</h1>
                    <div className="nums_wictory_combs">
                        {JsonNumWictory.map( (n) => <div key={n.id} className="item_num"><p>{n.num}</p></div>)}
                    </div>
                </div>
                <div className="block_info"> 
                    <span>
                        <img src="img/GreyBilet.png" alt=""/>
                        <div className="m_i">
                            <p>Купленных билетов:</p>
                            <h3>543</h3>
                        </div>
                    </span>
                    <span>
                        <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 8.68579C14.2523 8.68579 16.0781 6.85995 16.0781 4.60767C16.0781 2.35538 14.2523 0.529541 12 0.529541C9.74771 0.529541 7.92188 2.35538 7.92188 4.60767C7.92188 6.85995 9.74771 8.68579 12 8.68579Z" fill="#bebec0"/>
                            <path d="M20.25 8.68567C21.6739 8.68567 22.8281 7.53141 22.8281 6.10755C22.8281 4.68369 21.6739 3.52942 20.25 3.52942C18.8261 3.52942 17.6719 4.68369 17.6719 6.10755C17.6719 7.53141 18.8261 8.68567 20.25 8.68567Z" fill="#bebec0"/>
                            <path d="M3.75 8.68567C5.17386 8.68567 6.32812 7.53141 6.32812 6.10755C6.32812 4.68369 5.17386 3.52942 3.75 3.52942C2.32614 3.52942 1.17188 4.68369 1.17188 6.10755C1.17188 7.53141 2.32614 8.68567 3.75 8.68567Z" fill="#bebec0"/>
                            <path d="M6.29016 11.0009C5.27531 10.1694 4.35623 10.2795 3.18281 10.2795C1.42781 10.2795 0 11.6989 0 13.4431V18.5623C0 19.3198 0.618281 19.9357 1.37859 19.9357C4.66106 19.9357 4.26562 19.9951 4.26562 19.7942C4.26562 16.1667 3.83597 13.5065 6.29016 11.0009Z" fill="#bebec0"/>
                            <path d="M13.1161 10.2982C11.0665 10.1273 9.28506 10.3002 7.74845 11.5685C5.17703 13.6282 5.67189 16.4015 5.67189 19.7942C5.67189 20.6918 6.4022 21.4357 7.31345 21.4357C17.2079 21.4357 17.6017 21.7549 18.1885 20.4556C18.3809 20.0162 18.3281 20.1558 18.3281 15.9523C18.3281 12.6136 15.4372 10.2982 13.1161 10.2982Z" fill="#bebec0"/>
                            <path d="M20.8172 10.2794C19.6373 10.2794 18.7233 10.1704 17.7098 11.0008C20.1457 13.4878 19.7343 15.9665 19.7343 19.794C19.7343 19.9963 19.4061 19.9356 22.5722 19.9356C23.3597 19.9356 24 19.2976 24 18.5134V13.443C24 11.6987 22.5722 10.2794 20.8172 10.2794Z" fill="#bebec0"/>
                        </svg>
                        <div className="m_i">
                            <p>Победителей:</p>
                            <h3>25</h3>
                        </div>
                    </span>
                </div>
                <div className="kubok__price">
                    <div className="loto_time">
                        <img src="img/Kuboc.png" alt=""/>
                    </div>
                    <div className="time_items">
                        <div className="text_price">233 900 RUB</div>
                        <div className="text_procent">10187.12$</div>
                    </div>
                </div>
         </div>
        )
    }
    return(
        <div className="twoSection">
             <HeadLine headline="история лотерей" />

             <div className="container">
                 {JsonNumComdinations.map( (c) => <RenderCards key={c.id} /> )}
             </div>

             <span className="price_bilet"> 
                <p>Показать другие</p>
            </span>
        </div>
    )
}